import { contrastShade } from "../task-colors.js";

interface Props {
  done: boolean;
  /** Task accent hex — paints the ring, the done fill, and the check ink. */
  accent: string;
  label: string;
  onToggle: (done: boolean) => void;
}

/**
 * Round, task-colored completion control: empty ring → filled disc with a
 * drawn check. Deliberately framer-free — the check-draw is a pure CSS
 * animation (`.check-draw` in globals.css, reduced-motion aware) and the tap
 * feedback is an `:active` transform, so toggling state never spins up a JS
 * animation inside a row that may simultaneously be exit-animating.
 */
export function TaskCheck({ done, accent, label, onToggle }: Props) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={done}
      aria-label={label}
      onClick={(e) => {
        e.stopPropagation();
        onToggle(!done);
      }}
      className="grid h-[18px] w-[18px] shrink-0 cursor-pointer place-items-center rounded-full border-2 transition-transform duration-100 active:scale-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      style={{ borderColor: accent, background: done ? accent : "transparent" }}
    >
      {done && (
        <svg viewBox="0 0 12 12" className="h-3 w-3" aria-hidden>
          <path
            className="check-draw"
            d="M2.5 6.5 L5 8.7 L9.5 3.6"
            pathLength={1}
            fill="none"
            stroke={contrastShade(accent)}
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
}
